import { App } from "app-interfaces";
import React from "react";
import { Route, Switch } from "react-router-dom";

import { useStateValue } from "../config/AppContext";
import { DashboardListings } from "../components/Dashboard";
import HeadersComponent from "../components/Header";
// Global Components
import LoginComponent from "../components/Login";
import NavMenuComponent from "../components/Menus/NavMenu";
// Utilities
import Icons from "../components/Utilities/Icons";
import ClientsComponent from "./Clients";
// Pages
import ExercisesComponent from "./Exercises";
import SchedulesComponent from "./Schedules";
import SettingsComponent from "./Settings";
import WorkoutsComponent from "./Workouts";

const TopLevelRoutes: React.FC = () => {
  const { bg_layer } = Icons;
  const { authenticated } = useStateValue() as {
    authenticated: App.State["authenticated"];
  };
  return !authenticated ? (
    <div className="App" style={{ minHeight: "100%", backgroundImage: `url(${bg_layer})` }}>
      <LoginComponent />
    </div>
  ) : (
    <div className="App">
      <HeadersComponent />
      <NavMenuComponent />
      <div id="wrapper">
        <Switch>
          <Route exact path="/" component={DashboardListings} />
          <Route path="/settings" component={SettingsComponent} />
          <Route path="/clients" component={ClientsComponent} />
          <Route path="/exercises" component={ExercisesComponent} />
          <Route path="/workouts" component={WorkoutsComponent} />
          <Route exact path="/schedules" component={SchedulesComponent} />
        </Switch>
      </div>
    </div>
  );
};

export default TopLevelRoutes;
